import { render, staticRenderFns } from "./ValidPrecoOperadora.vue?vue&type=template&id=589baf99&scoped=true&"
import script from "./ValidPrecoOperadora.vue?vue&type=script&lang=js&"
export * from "./ValidPrecoOperadora.vue?vue&type=script&lang=js&"
import style0 from "./ValidPrecoOperadora.vue?vue&type=style&index=0&id=589baf99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589baf99",
  null
  
)

export default component.exports